export enum StaffContractEnum {
  'Part-time' = 1,
  'HDGV' = 2,
}
type StaffItemTypes = {
  id: number,
  fullname: string,
  dob: string,
  idCardNumber: string,
  idCardIssuedAt: string,
  idCardIssuedBy: string,
  taxCode: string,
  permanentAddress: string,
  contractType: StaffContractEnum,
  socialInsuranceNumber: string,
  socialInsuranceJoinDate: string,
  socialInsuranceImage: string | null,
  backIdCard: string | null,
  frontIdCard: string | null,
  phoneNumber: string
};

export type StaffBankDataTypes = {
  accountNumber: string,
  accountName: string,
  accountDefault: boolean,
  isActive: boolean,
  // bankCode: string,
  bankName: string,
  branchName: string,
  province?: {
    code: string,
    name: string
  },
  bankId: number
};

export type StaffResponseType = {
  staffData: StaffItemTypes & {
    socialInsuranceImagePath: string | null,
    frontIdCardPath: string | null,
    backIdCardPath: string | null
  },
  bankData: Array<StaffBankDataTypes>
};

export type StaffRequestType = Omit<StaffItemTypes, 'id' | 'contractType'> & {
  contractType: number,
  banks: Array<Omit<StaffBankDataTypes, 'bankName' | 'branchName' | 'province'> & { bankId: number }>,
  frontIdCard: string,
  backIdCard: string
};

export type OCRRequestDataTypes = {
  frontIdCardPath: string,
  backIdCardPath: string
};

export type OCRResponseDataTypes = {
  data: {
    idCardNumber: string,
    idCardName: string,
    idCardDob: string,
    idCardIssuedAt: string,
    idCardIssuedBy: string,
    idCardAddress: string
  }
};
